<template lang="pug">
#historico
    .row
        .col-12
            .div
                .safra
                    p.label-visualizacao {{ $t('mensagens.monitoramento.historico.agricola.tipoDeVisualizacao') }}
                    el-radio-group(
                        v-model='safraSelecionada',
                        @change='onChangeTipoSafra',
                        class='custom-radio-group'
                    )
                        el-radio.radio-custom(label='SAFRA' border) {{ $t('mensagens.monitoramento.historico.agricola.safra') }}
                        el-radio(label='SAFRINHA' border) {{ $t('mensagens.monitoramento.historico.agricola.safrinha') }}
            .row
                .col-12
                    .mapa-historico.row
                        .col-6
                            div.container-timeline
                                .timeline(v-loading='loadingHistorico')
                                    span(v-if='!dadosHistoricoFiltrados.length')
                                        empty-result.empty-result(
                                            :min-height='150',
                                            icon-class='mdi-alert-octagon',
                                            :message="$t('mensagens.monitoramento.historico.agricola.naoHaDadosHistoricosProcessadosParaArea')"
                                        )
                                    span.timeline-background(v-if='dadosHistoricoFiltrados.length > 0')
                                        timeline(
                                            :historico='dadosHistoricoFiltrados',
                                            @on-change='atualizarGeometriaAreaPlantada'
                                        )

                        .col-6
                            .mapa
                                mapa(
                                    v-if='layersMaps',
                                    :mapLayersConfigs='layersMaps',
                                    :mapConfig='mapConfig',
                                    :locked='true',
                                    height='340px',
                                    idMapa='mapaHistoricoAreaMonitorada',
                                    ref='mapa'
                                )

                                legenda(:values='legenda', ref='legenda')

        p.titulo-grafico {{ $t('mensagens.monitoramento.historico.agricola.areaColhida') }}
        .col-12.row-grafico(v-loading='loadingHistorico')
            card(:title="$t('mensagens.monitoramento.historico.agricola.areaColhida') + ' (ha)'", v-if='dadosHistoricoFiltrados')
                grafico-area-colhida(
                    ref='graficoAreaColhida',
                    :dadosHistorico='dadosHistoricoFiltrados'
                )
        p.titulo-grafico {{ $t('mensagens.monitoramento.historico.agricola.produtividade') }}
        .col-12.row-grafico(v-loading='loadingHistorico')
            card(:title="$t('mensagens.monitoramento.historico.agricola.produtividade') + ' (sc/ha)'", v-if='dadosHistoricoFiltrados')
                grafico-produtividade-media(
                    ref='graficoProdutividadeMedia',
                    :dadosHistorico='dadosHistoricoFiltrados'
                )
        p.titulo-grafico {{ $t('mensagens.monitoramento.historico.agricola.chuvaAcumuladaNoAno') }}
        .col-12.row-grafico(v-loading='!dadosClimaticos')
            card(:title="$t('mensagens.monitoramento.historico.agricola.chuva') + ' (mm)'")
                grafico-pluviosidade(
                    v-if='dadosClimaticos',
                    :historico='dadosClimaticos.precipitacao'
                )
        p.titulo-grafico {{ $t('mensagens.monitoramento.historico.agricola.temperaturaMediaDecorrerAno') }}
        .col-12.row-grafico(v-loading='!dadosClimaticos')
            card(:title="$t('mensagens.monitoramento.historico.agricola.temperatura') + ' (°C)'")
                grafico-temperatura(
                    v-if='dadosClimaticos',
                    :historico='dadosClimaticos'
                )
</template>

<script>
import L from 'leaflet';
import Card from '../Card';

import GraficoAreaColhida from './graficos/GraficoAreaColhida';
import GraficoProdutividadeMedia from './graficos/GraficoProdutividadeMedia';
import GraficoPluviosidade from './graficos/GraficoPluviosidade';
import GraficoTemperatura from './graficos/GraficoTemperatura';

import Timeline from './historico/Timeline';
import Mapa from '../MapaLeaflet';
import LayerStyle, { getEstiloCultura } from '../../utils/layerStyles';
import EmptyResult from '../EmptyResult';

import AreasMonitoradasService from '../../services/AreasMonitoradasService';
import Legenda from '../Legenda';
import { LEGENDA_MAPA_HISTORICO } from '../../utils/layouts/legendas';
import { CULTURAS } from '../../utils/TipoCultura';

import { sortBy } from 'lodash';

export default {
    name: 'Historico',

    props: {
        dadosAreaMonitorada: {
            type: Object,
            required: true
        }
    },

    components: {
        Timeline,
        Legenda,
        GraficoTemperatura,
        GraficoPluviosidade,
        GraficoProdutividadeMedia,
        GraficoAreaColhida,
        Card,
        Mapa,
        EmptyResult
    },

    data() {
        return {
            legenda: LEGENDA_MAPA_HISTORICO.map(item => ({
                ...item,
                name: item.name
            })),
            dadosHistorico: [],
            dadosHistoricoFiltrados: [],
            layersMaps: null,
            layerCulturas: null,
            loadingHistorico: true,
            mapConfig: {
                controls: {
                    zoomControl: true
                }
            },
            safraSelecionada: 'SAFRA',
            dadosClimaticos: null
            // coresTemperaturaMinima: ['#20E59A', '#1CB279', '#249268', '#267356', '#21634A', '#1A4334']
            // coresTemperaturaMinima: ['#95E1E1', '#91CCCC', '#81A7A7', '#5D7F7F', '#4D6666', '#344B4B']
        };
    },

    methods: {
        atualizarGeometriaAreaPlantada(idSafra) {
            if (!this.layerCulturas) {
                this.layerCulturas = L.layerGroup();
                this.$refs.mapa.mapa.addLayer(this.layerCulturas);
            } else {
                this.layerCulturas.clearLayers();
            }
            AreasMonitoradasService.geometriaHistoricoAgro(
                this.dadosAreaMonitorada.id,
                idSafra
            ).then(({ data }) => {
                let culturasExibidas = [];

                data.forEach(culturaPorSafra => {
                    const estilo =
                        getEstiloCultura(
                            CULTURAS[culturaPorSafra.cultura.codigo]
                        ) || LayerStyle.AREA_PLANTADA();

                    culturaPorSafra.geometrias.forEach(geometria => {
                        const layerCultura = L.geoJSON(geometria, estilo);
                        layerCultura.bindTooltip(culturaPorSafra.cultura.nome);

                        this.layerCulturas.addLayer(layerCultura);
                    });

                    culturasExibidas.push({
                        name: culturaPorSafra?.cultura?.codigo,
                        color: estilo.color
                    });
                });

                this.legenda = culturasExibidas.length > 0 ? culturasExibidas : LEGENDA_MAPA_HISTORICO.map(item => ({
                    ...item
                }));
            });
        },

        /*
			O serviço de histórico retorna os dados de todos os anos e safras, armazenados em this.dadosHistorico.
			Os dados referente à safra selecionada são mantidos na variável this.dadosHistoricoFiltrados.
			A cada vez que a safra ou a cultura são alteradas é preciso atualizar os dados filtrados. */
        atualizarDadosFiltrados() {
            this.dadosHistoricoFiltrados = [
                ...this.dadosHistorico.filter(
                    d => d.safra.tipoSafra === this.safraSelecionada
                )
            ];
            this.dadosHistoricoFiltrados = sortBy(
                this.dadosHistoricoFiltrados,
                ['safra.ano']
            ).reverse();
        },

        onChangeTipoSafra() {
            if (this.layerCulturas) {
                this.layerCulturas.clearLayers();
            }

            this.legenda = LEGENDA_MAPA_HISTORICO.map(item => ({
                    ...item
            }));

            this.atualizarDadosFiltrados();
        },

        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: this.$t('mensagens.monitoramento.historico.agricola.areaMonitorada'),
                geoJson: this.dadosAreaMonitorada.geometria
            };

            this.layersMaps.push(layerAreaMonitorada);
        },

        fetchHistoricoAgro() {
            this.loadingHistorico = true;
            AreasMonitoradasService.historicoAgro(this.dadosAreaMonitorada.id)
                .then(({ data }) => {
                    this.dadosHistorico = data;
                })
                .finally(() => {
                    this.configureLayersMapa();
                    this.loadingHistorico = false;
                    this.atualizarDadosFiltrados();
                    // if (this.dadosHistoricoFiltrados.length) {
                    // 	this.atualizarGeometriaAreaPlantada(this.dadosHistoricoFiltrados[0].id,
                    // 		this.dadosHistoricoFiltrados[0].safra.id);
                    // }
                });
        },

        fetchDadosHistoricosClima() {
            AreasMonitoradasService.historicoClimatico(
                this.dadosAreaMonitorada.id
            ).then(({ data }) => {
                this.dadosClimaticos = data;
            });
        }
    },

    created() {
        this.fetchHistoricoAgro();

        this.fetchDadosHistoricosClima();

        this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'V_HISTORICO_M_AGRICOLA', pageTitle: 'V_HISTORICO_M_AGRICOLA', routeName: this.$route?.name, routePath: this.$route?.path });
    }
};
</script>

<style lang="scss">
#historico {

    .mapa-historico {
        .col-6:first-child {
            padding-right: 0;
        }

        .col-6 {
            padding-right: 15px;
        }
    }

    .titulo-grafico {
        padding-left: 15px;
        margin-top: 15px;
        font-weight: 500;
        font-size: 16px;
    }

    .label-visualizacao-timeline {
        font-weight: 500;
    }

    .safra {
        margin-bottom: 20px;
        padding: 20px 20px;
        background-color: white;
        width: 100%;
        @include border-radii(4px, 4px, 4px, 4px);

        .label-visualizacao {
            font-weight: 500;
        }

        .el-radio.is-bordered.is-checked{
            border-color: #359138;

            .el-radio__label {
                color: #359138;
            }
        }

        .el-radio__input.is-checked .el-radio__inner {
            border-color: #359138;
            background-color: #fff;
        }

        .el-radio__inner::after {
            background-color: #359138;
            padding: 4px;
        }

        .custom-radio-group {
            display: flex;
            gap: 10px;
        }
    }

    .timeline {
        display: flex;
        position: relative;
        height: 100%;
        @include border-radii(4px, 0, 0, 4px);

        .row {
            margin: 0 !important;
            width: 100%;
        }

        span {
            width: 100%;
        }

        .empty-result {
            margin-top: 6rem;
        }
    }

    .container-timeline {
        background-color: white;
        border-radius: 5px;
        height: 340px;
        margin-right: left;
    }

    .mapa {
        position: relative;
    }

    #mapaHistoricoAreaMonitorada {
        @include border-radii(0, 4px, 4px, 0);
    }
}
</style>
